import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57e90142&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57e90142')) {
      api.createRecord('57e90142', component.options)
    } else {
      api.reload('57e90142', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57e90142&", function () {
      api.rerender('57e90142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/third/index.vue"
export default component.exports